import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {}

const { onRequest, onSuccess, onFailure } = rootActions.localization.keysList

function* keysListSagaTask({}) {
    const params = {}

    try {
        const response = yield axios.get(`/integrations/localization/keys-list`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* keysListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, keysListSagaTask)
}

export default keysListSaga
